import React from 'react'
import PropTypes from 'prop-types'
import focusable from '../Focusable/Focusable'
import FocusableButton from '../FocusableButton/FocusableButton'
import Checkmark from '../Icons/Checkmark/Checkmark'
import DeleteBtn from '../Icons/DeleteBtn/DeleteBtn'
import tts from '../../lib/TTS'

class NumericKeyboard extends React.Component {
  constructor(props) {
    super(props)
    this.digitsRefs = Array.from({ length: 12 }, () => React.createRef())
    this.keyLabels = { 9: <DeleteBtn />, 10: 0, 11: <Checkmark /> }
    this.state = { indexFocused: 0, amount: 0 }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.digitsRefs[this.state.indexFocused].current.setFocus()
      tts.addTextToRead('Focused on 1')
    }
  }

  formatValue = (value) => {
    const valueWithCents = parseFloat(value).toFixed(2)
    return valueWithCents.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  onKeyEvent(key) {
    let handled = true
    let changeIndexTo = null
    tts.stopRead()
    const { indexFocused } = this.state
    if (key == 0) {
      changeIndexTo = 10
      this.handleOnClick(10)
    } else if (key === 'BACK') {
      this.props.onClose()
    } else if (this.digitsRefs[key - 1]?.current) {
      changeIndexTo = key - 1
      this.handleOnClick(changeIndexTo)
    } else if (key === 'LEFT') {
      changeIndexTo = Math.max(0, indexFocused - 1)
    } else if (key === 'RIGHT') {
      changeIndexTo = Math.min(11, indexFocused + 1)
    } else if ('DOWN' === key && indexFocused + 3 <= 11) {
      changeIndexTo = indexFocused + 3
    } else if ('UP' === key && indexFocused - 3 >= 0) {
      changeIndexTo = indexFocused - 3
    } else {
      handled = false
    }

    if (changeIndexTo !== null && changeIndexTo !== indexFocused) {
      this.setState({ indexFocused: changeIndexTo })
      this.digitsRefs[changeIndexTo].current.setFocus()
      if (changeIndexTo === 9) {
        tts.addTextToRead('Focused on Delete')
      } else if (changeIndexTo === 10) {
        tts.addTextToRead('Focused on 0')
      } else if (changeIndexTo === 11) {
        tts.addTextToRead('Focused on Confirm')
      } else {
        tts.addTextToRead(`Focused on ${changeIndexTo + 1}`)
      }
    }
    return handled
  }

  handleOnClick = (index) => {
    const { amount } = this.state
    let newAmount = amount
    tts.stopRead()
    if (index === 9) {
      newAmount = +((amount - amount.toFixed(2).slice(-1) / 100) / 10).toFixed(
        2
      ) // Remove last digit
      tts.addTextToRead('Selected Delete')
    } else if (index === 10) {
      newAmount = amount * 10
      tts.addTextToRead('Selected 0')
    } else if (index === 11) {
      this.props.onConfirmedValue(amount, this.formatValue(amount))
      this.props.onClose()
      tts.addTextToRead('Selected Confirm')
    } else {
      newAmount = amount * 10 + (index + 1) / 100 // Add digit
      tts.addTextToRead(`Selected ${index + 1}`)
    }
    //Limit the number of digits so it doesn't overflow the component
    if (newAmount < 99999) {
      this.setState({ amount: newAmount })
    }
  }

  render() {
    return (
      <div className={`modal-container ${!this.props.show && 'hide'}`}>
        <div className="numeric-keyboard">
          <h3>${this.formatValue(this.state.amount)}</h3>
          {this.digitsRefs.map((digitRef, index) => (
            <FocusableButton
              parent={this}
              onClick={() => this.handleOnClick(index)}
              className="key"
              componentType="NumericKey"
              ref={digitRef}
              key={index}
            >
              {index < 9 ? index + 1 : this.keyLabels[index]}
            </FocusableButton>
          ))}
        </div>
      </div>
    )
  }
}

NumericKeyboard.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirmedValue: PropTypes.func,
}

export default focusable(NumericKeyboard)
